import styled from "styled-components";

export const Button = styled.button`
  font-size: 1.3rem;
  padding-bottom: 10px;
  background-color: #fff;
  border: 1px solid #d3d3d3;
  top: 15px;
  left: -15px;
  position: relative;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;
